import { render, staticRenderFns } from "./OTPSignature.vue?vue&type=template&id=cfeef208&"
import script from "./OTPSignature.vue?vue&type=script&lang=js&"
export * from "./OTPSignature.vue?vue&type=script&lang=js&"
import style0 from "./OTPSignature.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports